export enum WebEventNames {
  WEB_CATEGORY_VIEW = 'web-category.view',
  WEB_CATEGORY_ARTICLE_LIST_ENTER_ARTICLE = 'web-category.article-list.enter-article',
  WEB_CATEGORY_ARTICLE_LIST_ENTER_USER_PROFILE = 'web-category.article-list.enter-user-profile',
  WEB_CATEGORY_ARTICLE_LIST_LIKE = 'web-category.article-list.like',
  WEB_CATEGORY_BANNER_ENTER_AD = 'web-category.banner.enter-ad',
  WEB_CATEGORY_EC_PROMOTION_ENTER_LINK = 'web-category.ec-promotion.enter-link',
  WEB_CATEGORY_EC_PROMOTION_ENTER_POPSELECT_PRODUCTS = 'web-category.ec-promotion.enter-popselect-products',
}
